module.exports = __webpack_public_path__ + "static/media/surface.6d14ef43.png";